module.exports = __webpack_public_path__ + "static/media/react-star-wars.0984332a.svg";